import { Bar, BarProps } from 'victory';
import { getBarAlignmentAndWidth } from './bank-history-chart-utils';

export const CustomBar: React.FC<BarProps> = (props) => {
  if (props.datum.difference == 0) {
    return null;
  }

  return <Bar {...props} {...getBarAlignmentAndWidth(props)} />;
};
